import React, {useEffect} from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    ListItem,
    ListItemIcon,
    ListItemText,
    OutlinedInput,
    TextField,
    Typography
} from "@mui/material";
import Stack from "@mui/material/Stack";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import styled from "@mui/material/styles/styled";
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import List from "@mui/material/List";
import Div from "@jumbo/shared/Div";
import LoadingButton from "@mui/lab/LoadingButton";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import {useAppMutation} from "../../../../services";
import {useTranslation} from "react-i18next";
import teacherServices from "../../../../services/teacher-services";
import AddLinkOutlinedIcon from '@mui/icons-material/AddLinkOutlined';
import ZoomLink from './ZoomLink';
import NewsLetter from './NewsLetter';
import {useProfileContext} from "../context";
import AccessTimeFilledOutlinedIcon from "@mui/icons-material/AccessTimeFilledOutlined";
import Autocomplete from "@mui/material/Autocomplete";

const StyledListItemIcon = styled(ListItemIcon)(({theme}) => ({
    color: theme.palette.primary.main,
    fontSize: 24,
    height: 48,
    width: 48,
    borderRadius: '50%',
    minWidth: 42,
    marginRight: 16,
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
    border: `solid 1px ${theme.palette.divider}`
}));

const Settings = () => {

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openDialogLink, setOpenDialogLink] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState('');
    const [successMsg, setSucessMsg] = React.useState('');
    const {t} = useTranslation();
    const {globalState, setGlobalState} = useProfileContext();

    const {
        mutate: resetPassword,
        error,
        isError,
        isLoading,
        data: result,
        isSuccess
    } = useAppMutation(teacherServices.resetPassword);


    useEffect(() => {
        if (result && isSuccess) {
            console.log("Reset----", result, isSuccess)
        }
        if (isError && error) {
            setErrMsg(t('common.signInErrorMsg'))
            setTimeout(() => {
                setErrMsg("");
            }, 3000);
        }
        if (isSuccess) {
            setSucessMsg(t('teacher-profile.title.passwordReset'))
            setTimeout(() => {
                setSucessMsg("");
                setOpenDialog(false);
            }, 3000);
        }
        console.log('Reset-----------------------', isError, error, isSuccess, result)
    }, [result, isSuccess, isError])

    React.useEffect(() => {
        if (globalState.profile) {
            setValues({...globalState.profile})
            console.log("Settings-Profile----------", globalState);
        }
    }, [globalState])


    const handleEmailIconClick = () => {
        setOpenDialog(true);
    };

    const handleLinkDialog = () => {
        setOpenDialogLink(true);
    };

    const [values, setValues] = React.useState({
        password: '',
        newPassword: '',
        showPassword: false,
        showNewPassword: false,

    });


    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };


    const handleResetPassword = () => {
        if (!values.password) {
            setErrMsg(t('teacher-profile.title.currentPasswordMsg'))
            setTimeout(() => {
                setErrMsg("");
            }, 3000);
        } else if (!values.newPassword) {
            setErrMsg(t('teacher-profile.title.newPasswordMsg'))
            setTimeout(() => {
                setErrMsg("");
            }, 3000);
        } else if (values.password === values.newPassword) {
            setErrMsg(t('teacher-profile.title.differentPasswordMsg'))
            setTimeout(() => {
                setErrMsg("");
            }, 3000);
        } else if (values.newPassword.length < 8) {
            setErrMsg(t('teacher-profile.title.validPasswordMsg'))
            setTimeout(() => {
                setErrMsg("");
            }, 3000);
        } else if (!/(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9])/.test(values.newPassword)) {
            setErrMsg(t('teacher-profile.title.validationMsg'))
            setTimeout(() => {
                setErrMsg("");
            }, 3000);
        } else {
            console.log("Reset Password------------", values);
            resetPassword(values);
            setValues({
                password: '',
                newPassword: '',
                showPassword: false,
                showNewPassword: false,
            });
        }
    };


    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const handleClickShowNewPassword = () => {
        setValues({
            ...values,
            showNewPassword: !values.showNewPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    return (
        <JumboCardQuick
            title={
                <Typography variant={"h4"} mb={0}>{(t('teacher-profile.title.settings'))}</Typography>
            }
            wrapperSx={{pt: 0}}
            headerSx={{
                borderBottom: 1, borderColor: 'divider'
            }}
        >

            <List
                sx={{
                    width: '100%',
                    maxWidth: 360,
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexWrap: 'wrap',
                    margin: theme => theme.spacing(0, -2),
                }}
            >
                <ListItem>
                    <ListItemIcon>
                        <LockResetOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText id="switch-list-label-wifi" primary={(t('auth.resetPassword'))}/>
                    <Typography
                        variant="body1"
                        href="#"
                        onClick={handleEmailIconClick}
                        sx={{
                            fontSize: 15,
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                        underline="none"
                    >{(t('teacher-profile.title.reset'))}
                    </Typography>
                </ListItem>

                <ListItem>
                    <ListItemIcon>
                        <AddLinkOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText id="switch-list-label-wifi"
                                  primary={(t('teacher-profile.title.zoomLink'))}
                    />
                    <Typography
                        variant="body1"
                        href="#"
                        onClick={handleLinkDialog}
                        sx={{
                            fontSize: 15,
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                        underline="none"
                    >{(t('teacher-profile.title.link'))}
                    </Typography>
                </ListItem>

                {false && <ListItem>
                    <ListItemIcon>
                        <FeedOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText id="switch-list-label-bluetooth" primary={(t('teacher-profile.title.newsLetter'))}/>
                    <NewsLetter/>
                </ListItem>}
                {false && <ListItem sx={{display: 'flex', alignItems: 'center'}}>
                    <div style={{marginRight: '10px'}}>
                        <AccessTimeFilledOutlinedIcon/>
                    </div>
                    <Autocomplete
                        id="combo-box-demo"
                        getOptionLabel={(option) => option.title}
                        // options={allTimeZones}
                        sx={{width: '100%'}}
                        renderInput={(params) => <TextField {...params} label={t('common.timeZone')}/>}
                        disabled={true}
                    />
                </ListItem>}

            </List>

            <Div>
                <Dialog fullWidth open={openDialog}>
                    <DialogTitle>{(t('auth.resetPassword'))}</DialogTitle>
                    <DialogContent>

                        <FormControl fullWidth noValidate autoComplete="off">
                            <Div
                            >
                                <Div sx={{mt: 1, mb: 2}}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel
                                            htmlFor="outlined-adornment-password">{(t('common.password'))}</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type={values.showPassword ? 'text' : 'password'}
                                            value={values.password}
                                            onChange={handleChange('password')}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {values.showPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label={(t('common.password'))}
                                            required
                                        />
                                    </FormControl>
                                </Div>

                                <Div sx={{mt: 1, mb: 2, width: "100%"}}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel
                                            htmlFor="outlined-adornment-password">{(t('teacher-profile.title.newPassword'))}</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type={values.showNewPassword ? 'text' : 'password'}
                                            value={values.newPassword}
                                            onChange={handleChange('newPassword')}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowNewPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {values.showNewPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label={(t('teacher-profile.title.newPassword'))}
                                            placeholder="Example@123"
                                            required
                                        />
                                    </FormControl>
                                </Div>

                                <Stack
                                    sx={{
                                        mb: 2,
                                        width: '90%',
                                        mx: 'auto',
                                        display: 'block',
                                        position: 'relative', // Add position relative to enable absolute positioning of loader
                                    }}
                                    spacing={2}>
                                    {errMsg && <Alert severity="error">{errMsg}</Alert>}
                                    {successMsg && <Alert severity="success">{successMsg}</Alert>}
                                </Stack>

                                <Div sx={{display: 'flex', flexDirection: 'row', pt: 2}}>
                                    <Button
                                        sx={{mr: 1, width: "30%"}}
                                        onClick={() => setOpenDialog(false)}
                                    >
                                        {(t('common.closeBtn'))}
                                    </Button>
                                    <Div sx={{flex: '1 1 auto'}}/>


                                    <LoadingButton
                                        type="submit"
                                        variant="contained"
                                        size="large"
                                        loading={isLoading}
                                        onClick={handleResetPassword}
                                        sx={{width: "30%"}}
                                    >
                                        {(t('teacher-profile.title.reset'))}
                                    </LoadingButton>
                                </Div>

                            </Div>
                        </FormControl>
                    </DialogContent>
                </Dialog>
            </Div>


            <ZoomLink
                open={openDialogLink}
                onClose={() => setOpenDialogLink(false)}
            />

        </JumboCardQuick>
    );
};

export default Settings;
